import axios from './configAxios';

export const putVehicle = async (vehicleId, clientId, formData) => {
    return await axios.put(`vehicles/${vehicleId}/update/?client_id=${clientId}`, formData);
};
